<template>
  <section class="px-5">
    <LinkList :links="content.items" :title="content.title" class="max-w-255 mx-auto"/>
  </section>
</template>

<script lang="ts">
import {LinkList} from '@/components/blocks'

export default {
  name: 'LinksSection',
  components: {LinkList},
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>